import * as C from "../../../i18n/constants.mjs";
import { registerCondition } from "../conditionRegisterer.mjs";
export var CONDITION_NAME = 'none';

/**
 * @returns {boolean}
 */
export function condition() {
  return true;
}
registerCondition(CONDITION_NAME, condition, {
  name: C.FILTERS_CONDITIONS_NONE,
  inputsCount: 0,
  showOperators: false
});


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/filters/condition/none.mjs
// module id = 1394
// module chunks = 1